module.exports = __webpack_public_path__ + "img/9ec6824.jpeg";